import React, { Component } from "react";
import { Button, Card, Collapse, Elevation, Icon, } from "@blueprintjs/core";
import { DateRangeInput } from "@blueprintjs/datetime";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek"; // necesar pentru luni-duminică
import "./../../css/EventsOverview.scss";
// import "./../../css/Calendar.scss";
import "dayjs/locale/ro";
import { fetchTeamBySlug, getEventEndTime, capitalize } from "./../../utils/helpers";
import { BASE_API, AppToaster } from "./../../utils/constants";

dayjs.locale("ro");
dayjs.extend(isoWeek);

export default class TrainingOverview extends Component {
    state = {
        dateRange: [null, null],
        trainings: [],
        team: null,
        error: null,
        openDays: new Set(),
    };


    async componentDidMount() {
        const [start, end] = this.getCurrentWeekRange();
        const dateRange = [start.toDate(), end.toDate()];

        const search = this.props.location?.search || window.location.search;
        const urlParams = new URLSearchParams(search);
        const teamSlug = urlParams.get("echipa");
        const org = urlParams.get("org");
        this.setState({
            org, teamSlug
        })

        if (!teamSlug) {
            this.setState({ error: "Parametrul ?echipa lipsește" });
            return;
        }

        const team = await fetchTeamBySlug(teamSlug);
        this.setState({ dateRange, team }, () => {
            this.loadTrainingsForRange();
        });


    }

    handleDeleteEvent = async (eventId) => {
        if (!window.confirm("Ștergi evenimentul?")) return;

        const res = await fetch(`${BASE_API}/api/events/${eventId}`, {
            method: "DELETE",
        });

        if (res.ok) this.setState((s) => ({
            trainings: s.trainings.filter((ev) => ev.event_id !== eventId),
        }));
        else {
            const msg = await res.json();
            alert(msg.error || "Eroare la ștergere");
        }
        this.setState({ expandedCard: null, })
    };

    getCurrentWeekRange = () => {
        const today = dayjs();
        const startOfWeek = today.startOf("isoWeek"); // luni
        const endOfWeek = today.endOf("isoWeek"); // duminică
        return [startOfWeek, endOfWeek];
    };

    handleRangeChange = (range) => {
        this.setState({ dateRange: range }, () => {
            this.loadTrainingsForRange();
        });
    };


    loadTrainingsForRange = async () => {
        const { dateRange, team } = this.state;
        if (!team || !dateRange[0] || !dateRange[1]) return;

        const from = dayjs(dateRange[0]).format("YYYY-MM-DD");
        const to = dayjs(dateRange[1]).format("YYYY-MM-DD");

        try {
            const response = await fetch(`${BASE_API}/api/events?team=${team.id}&from=${from}&to=${to}`);
            const data = await response.json();
            if (!data?.events) {
                this.setState({ trainings: [] });
                return;
            }

            const trainings = data.events.filter((ev) => ev.event_type === "training");
            this.setState({ trainings });
        } catch (err) {
            console.error("Eroare la fetch antrenamente:", err);
            this.setState({ trainings: [] });
        }
    };

    toggleDay = (iso) =>
        this.setState((p) => {
            const next = new Set(p.openDays);
            next.has(iso) ? next.delete(iso) : next.add(iso);
            return { openDays: next };
        });


    render() {
        const { dateRange } = this.state;
        console.log('STATE..', this.state)

        return (
            <div className="calendar-layout screen-portrait">
                <div className="header-row">
                    <div className="left-side">
                        <span className='font-light-blue hide-sm'>Perioada: </span>
                        <div className="fm-time-range-picker">
                            <DateRangeInput
                                allowSingleDayRange={true}
                                shortcuts={true}
                                closeOnSelection={true}
                                formatDate={(d) => dayjs(d).format("DD.MM.YYYY")}
                                parseDate={(str) => dayjs(str, "DD.MM.YYYY").toDate()}
                                value={dateRange}
                                onChange={this.handleRangeChange}
                                locale="ro" // 🔥 funcționează corect – începe cu luni
                            />
                        </div>
                    </div>

                    <div className="right-side">
                        <Button
                            className=" rounded-sm-btn bkg-seagreen"
                            onClick={() => {
                                const { org, teamSlug } = this.state;
                                const team_id = this.state?.team?.id;
                                const addUrl = `/echipa?org=${org}&echipa=${teamSlug}&view=training-details&action=add&team_id=${team_id}`;
                                window.location.href = addUrl
                                // console.log(addUrl)

                            }}
                        >
                            <span className="font-white">Adauga antrenament</span>
                        </Button>
                    </div>
                </div>

                <div className="trainings-section">
                    {this.state.trainings.length === 0 ? (
                        <div className="empty-message">
                            <img src='/icons/vacation.png' />
                            <p>Săptămâna asta nu e programat niciun antrenament.</p>
                            <p>Selectează altă perioadă.</p>
                        </div>
                    ) : (
                        <ul className="trainings-list">
                            {this.state.trainings.map((tr) => {
                                let { event_date, event_id, event_type, training_duration, description, location, training_type, event_time } = tr

                                const { org, teamSlug } = this.state;
                                const team_id = this.state?.team?.id;
                                const editUrl = `/echipa?org=${org}&echipa=${teamSlug}&view=training-details&action=edit&event_id=${tr.event_id}&team_id=${team_id}`;


                                const date = dayjs(event_date);

                                // 📆 Outputs:
                                const dayName = date.format("dddd");  // ex: "marți"
                                const dayNumber = date.format("D");     // ex: "22"
                                const monthName = date.format("MMMM");
                                const iso = date.toISOString();
                                let openDays = this.state?.openDays;
                                const isOpen = openDays.has(iso)
                                console.log(iso)

                                return <div key={event_id} className="calendar-grid-item">
                                    <Card key={iso} className={'calendar-day training-day'} elevation={Elevation.ONE}>
                                        <div className="card-wrapper">
                                            <div className="xl-card">
                                                <div className="day-header" onClick={() => this.toggleDay(iso)}
                                                >
                                                    <span className="day-text">
                                                        <span className="day-nr">{dayNumber} {monthName}, </span>
                                                        <span className="day-name">{capitalize(dayName)}</span>
                                                    </span>
                                                    <div className={`day-status content-label font-title-antrenament`}>
                                                        Antrenament
                                                        {training_type &&
                                                            <div className='fm-tag-row'>{training_type.split(",").map((tip, index) => {
                                                                if(tip)
                                                                    return <span key={index} className="fm-tag">{tip.trim()}</span>
                                                            }
                                                            )}
                                                            </div>}
                                                    </div>

                                                    <span className="add-text"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            window.location.href = editUrl

                                                            // this.openAddDialog(dateObj);
                                                        }}
                                                    >
                                                        <Icon icon='edit' size={14} /> Editeza
                                                    </span>
                                                </div>

                                                <Collapse isOpen={isOpen}>
                                                    <div className="day-content">
                                                        <div key={event_id} className="content-row-group">
                                                            <div className='row-2 '>
                                                                <div className="col1">

                                                                    <div className="font-p">Locatie: {location}</div>
                                                                    <div className="font-p">Ora: {event_time}  {event_type === "training" && (' - ' + getEventEndTime(event_time, training_duration))}</div>

                                                                    {description &&
                                                                        <div className="font-p-2 ">Note: <span className="font-lowercase font-roboto-light">{description}</span></div>

                                                                    }
                                                                    <div className='delete-btn' onClick={() => this.handleDeleteEvent(event_id)}>Sterge <Icon icon="trash" className="delete-ev" title="Șterge" /></div>

                                                                </div>
                                                                <div className="col2">
                                                                    <img className="game-icon" src={event_type === "game" ? "/icons/cup.png" : "/icons/training.png"} alt={event_type === "game" ? "Joc" : "Antrenament"} />
                                                                    <div className="font-mont">{event_type === "game" ? "TIME TO WIN" : "TIME TO TRAIN"}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* {events.length ? events.map(this.renderXLEvent) : ''} */}
                                                    </div>
                                                </Collapse>
                                            </div>

                                        </div>
                                    </Card>
                                </div>
                            }



                                // <li key={tr.event_id} className="training-item">
                                //     <strong>{dayjs(tr.event_date).format("DD.MM.YYYY")}</strong> – Antrenament {tr.training_type} ({tr.location || "fără locație"})
                                // </li>
                            )}
                        </ul>
                    )}
                </div>
            </div>
        );
    }
}



